import { createSlice } from '@reduxjs/toolkit';
import Cookie from 'js-cookie';

let cart = [];
if (Cookie.get('cart')) cart = JSON.parse(Cookie.get('cart'));

// console.log(cart);

let itemName = [];
if (Cookie.get('itemName')) itemName = JSON.parse(Cookie.get('itemName'));
else itemName = [];

export const cartSlice = createSlice({
    name: 'cart',
    initialState: {
        value: cart,
        itemName: itemName,
        error: '',
        itemToShow: null
    },
    reducers: {
        addToCart: (state, payload) => {

            if (!state.itemName.includes(payload.payload.name)) {

                // console.log('not in cart')
                state.value.push(payload.payload);
                state.itemName.push(payload.payload.name);

                Cookie.set('itemName', JSON.stringify(state.itemName), {expires: 7})
                Cookie.set('cart', JSON.stringify(state.value), { expires: 7 });
                Cookie.set('lastViewed', JSON.stringify(state.value), { expires: 7 })

                state.itemToShow = payload.payload;
                state.error = ''

            } else state.error = 'Oops this item is already in your cart!';
            // console.log(payload.payload)

        },
        initialShow: (state) => {
            state.itemToShow = null;
        },
        initialError: (state) => {
            state.error = '';
        },
        removeFromCart: (state, payload) => {

            const arr = state.value.filter(a => a.name !== payload.payload);
            Cookie.set('cart', JSON.stringify(arr), { expires: 7 })

            const itemArr = state.itemName.filter(a => a !== payload.payload)
            Cookie.set('itemName', JSON.stringify(itemArr), { expires: 7 })
            state.itemName = itemArr;
            state.value = arr;

        },
        incrementCart: (state, payload) => {
            state.value[payload]++;
        }
    }
})

export const { incrementCart, addToCart, removeFromCart, initialShow, initialError } = cartSlice.actions;

export default cartSlice.reducer